import React from "react";
import {
  Avatar,
  Button,
  Card,
  CardContent,
  Modal,
  Typography,
} from "@mui/material";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

const ModalBadgeOfUser = ({ showModal, setShowModal, badge }) => {
  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card sx={{ width: 300, p: 2 }}>
        <CardContent sx={{ textAlign: "center" }}>
          <Typography className=" text-center  text-[16px] font-HankenGroestk mb-3">
            {badge?.blocked
              ? "¡Felicidades ha desbloqueado esta insignia!"
              : "Vamos tu puedes sigue así para desbloquear la insignia"}
          </Typography>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              mx: "auto",
              bgcolor: badge?.blocked ? "#e7ef7d" : "grey.500",
            }}
          >
            <WorkspacePremiumIcon fontSize="large" />
          </Avatar>
          <Typography variant="h6" sx={{ mt: 2 }}>
            {badge?.nameBadge || "Insignia"}
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            {badge?.description || "Descripción no disponible"}
          </Typography>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#e7ef7d", mt: 3 }}
            onClick={() => setShowModal(false)}
          >
            Cerrar
          </Button>
        </CardContent>
      </Card>
    </Modal>
  );
};

export default ModalBadgeOfUser;
